// extracted by mini-css-extract-plugin
export default {"Large":"FAQImg_Large__o3sCo","Normal":"FAQImg_Normal__2euts"};